import React from "react";
import PropTypes from "prop-types";

import "./styles/components/SecondaryButton.css";

const SecondaryButton = props => {
  return (
    <div className={`u-align-${props.align}`}>
      <div
        onClick={props.handleClick}
        className={`btn-text btn-text__${props.buttonColour}`}
      >
        {props.buttonText}
      </div>
    </div>
  );
};

SecondaryButton.defaultProps = {
  align: "center",
  buttonColour: "2",
  buttonText: "Button"
};

SecondaryButton.propTypes = {
  align: PropTypes.string.isRequired,
  buttonColour: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired
};

export default SecondaryButton;



// WEBPACK FOOTER //
// ./src/components/layout/SecondaryButton.js